module.exports = __webpack_public_path__ + "img/clock.51e7f6ae.svg";